export default __webpack_public_path__ + "static/media/Big.a06d7c19.jpg";